import React from 'react';
import PropTypes from 'prop-types';
import CustomerRow from "./components/CustomerRow/index";
import queryString from 'query-string';
import AuthService from '../../../../services/AuthService';

export default class MemberTable extends React.Component {

    render() {
        // If no results, show nothing
        if (this.props.members.length === 0) {
            return null;
        }

        // Build table rows
        const rows = [];
        this.props.members.forEach((member) => {
            rows.push(
                <CustomerRow
                    key={member.futuraCustomerId}
                    customer={member}
                    query={this.props.query}
                    actualSearchKey={this.props.actualSearchKey}
                />
            );
        });

        // Display table
        return (
            AuthService.can('View member') &&
            <div className="container container--wide container--responsive">
                <div className="table--overflow clearfix">
                    <table>
                        <thead>
                            <tr>
                                <th>First Name</th>
                                <th>
                                    <span href="#" className="btn btn--circle is--desc">
                                        <img src="/img/icon-arrowDown--red.svg" alt="" className="icon icon--arrowDown" />
                                    </span>
                                    Surname
                                </th>
                                <th>Email</th>
                                <th>Suburb/State</th>
                                <th>Postcode</th>
                                <th>Card Number</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                            {this.props.members.length === 0 &&
                                <tr>
                                    <td colSpan="5">No results founds.</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

MemberTable.propTypes = {
    members: PropTypes.array.isRequired,
    query: PropTypes.string,
    actualSearchKey: PropTypes.string
};
